import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import Settings from './../../resources/setts.js'; //Settings
import PaymentService from './../PaymentService/index.vue'; //
import Checkout from './../Orderpoint/Checkout/index.vue'

let service = new services();
export default {
    name: 'Home',
    mixins: [Settings],
    data () {
        return {
            header_data:{},
            user:{},
            transfer:{},
            transfers:{},
            transfer_item:{},
            transfer_ref:'',
            loggedIn: false,
            loading: true,
            action_loading:false,
            tab_view: {},
            menu_tab_view:{},
            set_view:false,
            set_payment:false,
            payment_data:{},
            img_product_url: service.imageProductsURL,
            show_empty_fields:false,
            data_processing_message:'',
            show_login_view:false,
            data_view:'',
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-payment-service': PaymentService,
        'component-checkout': Checkout,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                //this.setComponent('reset-edit','');
            }else{
                //this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
            //
            if(view == "viewTransfer"){
                this.transfer = attr1;
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    // self.getTransferOrders();
                    self.getGeneratedTransferOrders();
                    self.loading = false;
                }else {
                    self.show_login_view = true;
                    //self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        addProductsToTransferOrder(){

        },

        makeTransFerOrder(){
            // let order_items = [];
            // //
            // let item = {
            //     order_item_id: 9,
            //     order_item_order_quantity:2,
            // }
            // let item2 = {
            //     order_item_id: 10,
            //     order_item_order_quantity:3,
            // }
            // order_items.push(item);
            // order_items.push(item2);
            // //
            // var payload = {
            //     order_user:this.user.user_id,
            //     order_payment_order:14,
            //     order_items:order_items,
            // }
            //
            if((this.transfer.payment_order_id > 0) && (Object.keys(this.transfer.payment_order_items).length > 0)){
                var payload = {
                    order_user:this.user.user_id,
                    order_payment_order:this.transfer.payment_order_id,
                    order_items:this.transfer.payment_order_items,
                }
                service.acceptPaymentOrder(this, payload).then(response => {
                    if(response.body.status == 201) {
                        console.log(response.body)
                    }
                }).catch((err) => {})
            }
        },

        setGenerateReceipt(){
            let self = this;
            //activate dynamic request
            var request_data = {
                "name": "GenerateTransferPayment", //use route component name
                "link": "/account/business/generatetransferpayment",
                "dir": "/account/business",
                "src": "/transfer",
                "msg": "Login to check your Transfers",
                "track": 1, //created//started
            }
            localforage.setItem(service.adr_db_name, request_data).then(function (value) {
                self.$router.push(request_data.link);
            }).catch(function(err) {
                //console.log(err)
            });
        },

        setTabActiveDisplay(tab){
            if(tab == "invoices"){
                document.getElementById("t_invoice").style.color = "#ff0000";
                document.getElementById("t_payment").style.color = "#000000";
            }

            if(tab == "payments"){
                document.getElementById("t_payment").style.color = "#ff0000";
                document.getElementById("t_invoice").style.color = "#000000";
            }
        },

        getGeneratedTransferOrders(){
            //set tab active display
            this.setTabActiveDisplay("invoices");
            this.data_view = "invoices";
            this.action_loading = true;
            this.transfers = {}; //reset
            var payload = {
                order_user: this.user.user_id,
                order_generated_request:1
            }
            service.getPaymentOrders(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.transfers = response.body.data; 
                }
                this.loading = false;
                this.action_loading = false;
            }).catch((err) => {})
        },
        
        getTransferOrders(){
            //set tab active display
            this.setTabActiveDisplay("payments");
            this.data_view = "Payments";
            this.action_loading = true;
            this.transfers = {}; //reset
            var payload = {
                order_user: this.user.user_id,
            }
            service.getPaymentOrders(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.transfers = response.body.data; 
                }
                this.loading = false;
                this.action_loading = false;
            }).catch((err) => {})
        },

        getTransferDetails(){
            var payload = {
                order_ref: this.transfer_ref,
            }
            service.getPaymentOrders(this, payload).then(response => {
                if(response.body.status == 200) {
                    let set_data = response.body.data;
                    this.transfer = set_data[0];
                    this.setMenuTabView('viewTransfer',this.transfer);
                }
                this.loading = false;
            }).catch((err) => {})
        },

        setUserData(){
            this.show_empty_fields = false; 
            this.preparePaymentData();
        },

        //
        preparePaymentData(){
            //
            // this.payment_data.payment_currency = "NGN";
            // this.payment_data.payment_total_amount = 3400;
            // this.payment_data.payment_transaction_type = 1;
            // this.payment_data.payment_modes_accepted = [1,2,3,4,5];
            // this.payment_data.payment_fees_account_balance = 200;

            //

            //make order 

            //get the order details 

            //set payment data
            if(this.transfer.payment_order_payment_status_id == 7){
                this.setPaymentDataSlim();
            }
            //set view
            //this.set_payment = true;
        },

        setPaymentDataSlim(){
            let set_payment_data = {};
            //
            let order = this.transfer.payment_order_order_details;
            let order_data = this.transfer.payment_order_order_data;
            //
            //
            //
            set_payment_data.order_ref = order.order_no;
            //
            this.payment_data = set_payment_data;
            //set view
            this.set_payment = true;
        },

        setPaymentData(){
            //
            let order = this.transfer.payment_order_order_details;
            let order_data = this.transfer.payment_order_order_data;
           // this.set_order_pending_payment_data = "ord"+order_index;

            //settings
            let payment_orders_data = order; //the actual payment orders
            let payment_amount_to_pay = order.total_amount;
            let payment_ref =  order.order_ref;
            let payment_details = order_data.payment_service;
            let payment_service_module = order_data.payment_service_module;
            let payment_service_module_id = order_data.payment_service_module_id;
            //prepare orders data in payment
            
            //prep order settins
            let set_subaccounts = [];
            let set_subaccounts_settlements = true; //default
            //prep subaccounts
            if(set_subaccounts_settlements){
                //--check if agentsco and commissions
                //----agents
                if(order.order_agent_fee > 0){
                    var sub_account_0 = {
                        id: order.business_agent_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: (order.order_agent_fee),
                        transaction_charge_type: "flat_subaccount"
                    }
                    set_subaccounts.push(sub_account_0);
                }
                //----commissions
                if(order.order_total_commissions_fee > 0){
                    var sub_account_01 = {
                        id: service.spcomms_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: (order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    }
                    set_subaccounts.push(sub_account_01);
                }
                //---check if order shipping is born by this business or a delivery company
                let order_business = 0;
                let order_delivery_business = order.order_delivery_business.business_delivery_id;
                if(order_business == order_delivery_business){//order shipping is born by this business
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: (order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee)),
                        transaction_charge_type: "flat_subaccount"
                    }
                    set_subaccounts.push(sub_account_1);
                }else{ //order shipping is not born by this business
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: (order.total_amount - (order.order_delivery_fee + order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee)),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                    var sub_account_2 = {
                        id: order.order_delivery_business.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: (order.order_delivery_fee),
                        transaction_charge_type: "flat_subaccount"
                    }
                    set_subaccounts.push(sub_account_2);
                }
            }
            //..//prep sub accounts
            //...set sub accounts

            //set users details
            if((this.user.user_email == undefined) || (this.user.user_phone == undefined) || (this.user.user_email == "") || (this.user.user_phone == "")){
                this.user.user_name = order_data.payment_data.payment_payer_name;
                this.user.user_email = order_data.payment_data.payment_payer_email;
                this.user.user_phone = order_data.payment_data.payment_payer_phone;
            }

            //set user details
            let set_payment_data = {};
            if((this.user.user_email == undefined) || (this.user.user_phone == undefined) || (this.user.user_email == "") || (this.user.user_phone == "")){
                this.show_empty_fields = true;
            }else{
                set_payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: payment_amount_to_pay,
                    payment_currency: "NGN", //default //can change from form
                    // pay_payment_ref: this.broker_request.broker_request_ref+Math.floor(Math.random() * 5),
                    payment_ref: payment_ref,
                    payment_details: payment_details,
                    payment_processing_fee_status:4, //buyer pays
                    payment_processing_fee: 0, //not set
                    payment_processing_fee_transaction_type:0, //not set
                    payment_transaction_type: 1, ////order payment
                    payment_service_module: payment_service_module,
                    payment_service_module_id: payment_service_module_id,
                    payment_data_index: 0, //default
                    payment_data_route: "account", //account page
                    payment_service_business:order.order_business, //not set
                    payment_service_type:"single", //recheck
                    payment_service_payment_data:order_data.payment_data, //payment_data
                    payment_sub_accounts: set_subaccounts, 
                    payment_fees_account_balance:0,//this.sellpoint.business_processing_fee_balance,
                    payment_meta: [],
                    payment_modes_accepted: [1,5], //1-Auto payments //5--Payment/ProcessingFee Payment
                }
                //add-on to payment data
                set_payment_data.payment_service_payment_data.payment_services = payment_orders_data;
                this.show_empty_fields = false;
            }

            //set data
            this.payment_data = set_payment_data;
            
            //set view
            this.set_payment = true;
        },

        
    },
    created: function(){
        //this.preset();
        this.header_data.name = "Transfers";
        //
        if((this.$route.params.ref != undefined) && (this.$route.params.ref != '')){
            this.transfer_ref = this.$route.params.ref; 
            this.getTransferDetails();
        }else{
            this.preset();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Transfer/script.js